<template>
  <div class="media align-items-center mb-3 d-flex">
    <AppAvatar
      v-if="img"
      :src="img"
      alt=""
      :size="avatarSize"
      :circle="imgCircle"
      :clickable="hasPreview"
      @click="handleAvatarClick"
    />
    <p class="ml-3 my-auto mr-2" v-if="title">{{ title }}</p>
    <div class="ml-auto mr-0 map-panel-first-row__meta">
      <div class="text-muted mb-1" v-if="id">ID: {{ id }}</div>
      <b-btn variant="secondary" size="sm" @click="edit" v-if="hasEdit">Edit</b-btn>
    </div>

    <!-- Image Preview Modal -->
    <AppModal
      v-if="showAvatarPreview"
      :show-close-icon="true"
      :close-on-esc="true"
      @close="closeAvatarPreview"
    >
      <AppImagePreview
        :image-src="previewAvatarSrc"
      />
    </AppModal>
  </div>
</template>

<script>
import AppAvatar from '@/components/shared/AppAvatar.vue'
import AppModal from '@/components/shared/AppModal.vue'
import AppImagePreview from '@/components/shared/AppImagePreview.vue'

export default {
  name: 'AppMapPointPanelFirstRow',
  components: { AppAvatar, AppModal, AppImagePreview },
  data: () => ({
    showAvatarPreview: false,
    previewAvatarSrc: '',
  }),
  props: {
    title: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    },
    imgCircle: {
      type: Boolean,
      default: true
    },
    hasPreview: {
      type: Boolean,
      default: false
    },
    id: {
      type: [Number, String],
      default: ''
    },
    hasEdit: {
      type: Boolean,
      default: false
    },
    avatarSize: {
      type: String,
      default: '48px'
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    },
    handleAvatarClick(imageSrc) {
      this.previewAvatarSrc = imageSrc
      this.showAvatarPreview = true
    },
    closeAvatarPreview() {
      this.showAvatarPreview = false
      this.previewAvatarSrc = ''
    }
  }
}
</script>

<style scoped>
.map-panel-first-row__meta > * {
  white-space: nowrap;
}
</style>
